import { some } from "@cdv/jazz-auth";
import { CurrentUser, User, UserRole } from "../api";

export const isAdmin = (user: CurrentUser): boolean => user.role === UserRole.Admin;

export const isAppuser = (user: CurrentUser): boolean => user.role === UserRole.AppUser;
